import styled, { css } from 'styled-components';

import { ReactComponent as CalendarIcon } from '../../../assets/images/blueTheme/calendarIcon.svg';
import Select from '../../Select';

export const SharedDatePickerStyles = css<{ $hasError?: boolean; width?: string }>(
  ({ theme: { spacers, admanColors, colors }, $hasError, width }) => css`
    padding: 0;
    font-family: InspireTWDC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    input {
      font-family: inherit;
      border: 1px solid ${$hasError ? colors!.colorRedBase : admanColors!.gray.light.fg[5]};
      border-radius: 4px;
      padding: 9.5px ${spacers?.spacer03};
      display: block;
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      font-size: 14px;

      &:disabled {
        background-color: ${admanColors!.gray.light.bg2[7]};
        color: ${admanColors!.gray.dark.fg[6]};
      }
    }

    .valueContainer div {
      font-family: InspireTWDC;
    }

    .dropdownIndicator svg {
      height: 16px;
      opacity: 0.7;
    }

    .option {
      font-family: InspireTWDC;
    }

    .react-datepicker-wrapper {
      input:focus-visible {
        border: 1px solid ${admanColors!.gray.light.fg1[0]};
        outline: none;
        box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]};
      }
    }

    > input:first-child {
      &:focus-visible {
        border: 1px solid ${admanColors!.gray.light.fg1[0]};
        outline: none;
        box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]};
      }
    }

    .react-datepicker__input-container {
      font-family: InspireTWDC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;

      &:focus-visible {
        border: 1px solid ${admanColors!.gray.light.fg1[0]} !important;
        box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]};
      }
    }

    .react-datepicker__header {
      margin-right: 0 !important;
      background: ${admanColors!.gray.light.bg0[0]};
      border: none;
    }

    .react-datepicker {
      line-height: normal;
      max-width: 612px;
    }

    .react-datepicker__day--outside-month {
      color: transparent;
      pointer-events: none;
    }

    .react-datepicker__triangle {
      display: none;
    }

    .react-datepicker-popper {
      padding-top: 0;
    }

    .react-datepicker__day-name {
      visibility: hidden;
      width: 36px;
    }

    .react-datepicker__day-name::first-letter {
      display: block;
      visibility: visible;
      font-family: InspireTWDC;
      font-size: 18px;
      font-style: normal;
      padding-left: ${spacers?.spacer01};
      font-weight: 500;
      line-height: 21px;
      width: 36px;
      color: ${admanColors!.gray.light.fg1[1]};
    }

    .react-datepicker__day--today {
      border-bottom: 2px solid ${admanColors!.blue.dark.bg2[0]};
    }

    .react-datepicker__day {
      font-family: InspireTWDC;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 21px;
      width: 36px;
      color: ${admanColors!.gray.dark.fg1[0]};
      padding: ${spacers?.spacer02};

      &:hover {
        background-color: ${admanColors!.blue.dark.bg1[7]};
      }
    }

    .react-datepicker__day--selected {
      background-color: ${admanColors!.blue.dark.bg1[7]};
    }

    .react-datepicker__day--keyboard-selected {
      background: ${admanColors!.blue.light.fg[3]};
    }

    .react-datepicker__day--outside-month {
      visibility: hidden;
    }

    .react-datepicker__day--disabled {
      color: ${admanColors!.gray.light.fg1[0]};
    }

    .valueContainer input {
      height: auto;
    }
  `
);

export const DatePickerContainer = styled.div<{ $hasError?: boolean; width?: string }>(
  ({ theme: { admanColors, spacers, colors }, $hasError, width }) => css`
    width: ${width || '50%'};
    position: relative;

    ${SharedDatePickerStyles}

    .react-datepicker__month {
      margin: 0;
      padding: 0 ${spacers?.spacer04} ${spacers?.spacer05} ${spacers?.spacer04};
    }
  `
);

export const StyledErrorText = styled.div`
  color: ${({ theme }): string => theme.colors!.colorRedBase};
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0;
  margin: ${({ theme }): string => theme.spacers!.spacer01} 0;
`;

export const StyledDatePickerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }): string => theme.spacers!.spacer04};
`;

export const StyledSelectMonth = styled(Select)`
  width: 115px;
`;

export const StyledSelectYear = styled(Select)`
  width: 90px;
`;

export const StyledArrowWrapper = styled.div<{ disabled?: boolean }>(
  ({ disabled }) => css`
    opacity: ${disabled ? 0.5 : 1};

    &:hover {
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    }
  `
);

export const StyledCalendarIcon = styled(CalendarIcon)`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
`;

export const StyledLabel = styled.div`
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-bottom: ${({ theme }): string => theme.spacers!.spacer01};
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[1]};
`;
